// @flow
import * as React from 'react'
import { Route } from 'react-router-dom'
import NoMatch from 'ui/NoMatch'

export default class NotFoundRoute extends React.Component<{}> {
  render = () => {
    return <Route component={NoMatch} />
  }
}
